import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setSubTitle } from "../stores/AppReducer";
import { getIndex } from "../services/newsService";
import type { AppDispatch } from "../stores/AppStore";


function Home() {
    // const app: IAppState = useSelector((appState: IApplicationState) => appState.app);
    const dispatch = useDispatch<AppDispatch>();
    useEffect(() => {
        dispatch(setSubTitle("Willkommen in der Informations-Souveränität"));
        dispatch(getIndex(null));
    }, []);
    return (
        <div className="home">
            {/* <img src="/cgi-bin/API.cgi/news/picture?4709274d5392cc921f5a.webp"/> */}
            <p>
                Das Internet gehört nicht den großen Tech-Konzernen. Und, das Internet ist nicht kostenlos. 
                Dabei sind mit Kosten nicht die Verbindungskosten gemeint, die man für den Internetanschluss bezahlt.
                Webserver-Dienste zu erstellen und zu betreiben kostet viel Geld.
                <br/>
                Jeder, der einen solchen Dienst nutzt und dafür nur die Verbindungskosten zahlt, 
                sollte sich die Frage stellen: "Warum machen die das?"
                Eines dürfte dabei klar sein, reine Nächstenliebe ist es sicherlich nicht.  
            </p>
            <p>
                Nun stellt sich die Frage: Wie kommuniziert man digital mit Familie, mit seinen Freuden und Bekannten, 
                ohne die üblichen Dienste?
            </p>
            <p>
                Diese Website ist ein Versuch es <a href="/#/authlink" >anders</a> zu machen.
            </p>
            <p>
                Und wenn es Dich interessiert, wie es mal mit dem Internet angefangen hat, dann schau <a href="#/news/:RootOfWWW.html">hier</a>.
            </p>
            <br/>
        </div>
    );
}
export default (Home);
